import type { AEyebrowProps } from '../../atoms/AEyebrow/AEyebrow.types';
import type { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import type { AAccentLineProps } from '../../atoms/AAccentLine/AAccentLine.types';
import type { ABodyProps } from '../../atoms/ABody/ABody.types';
import type { MButtonProps } from '../../molecules/MButton/MButton.types';
import type { MTagProps } from '../../molecules/MTag/MTag.types';
import type { MMediaImageProps } from '../../molecules/MMediaImage/MMediaImage.types';

export enum OCardStandardContentAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export enum OCardStandardPadding {
  None = 'None',
  ContentOnly = 'Content Only',
  EntireCard = 'Entire Card',
}

export interface OCardStandardTrackingProperties {
  location?: string;
  trackingTag?: string;
  trackingContentPosition?: string;
  trackingDescription?: string;
  trackingOfferType?: string;
  merchandisingCategory?: string;
  atCCeVar48?: string;
  clickTrack?: boolean;
  impressionTrack?: boolean;
  impressionCount?: boolean;
  enableScrollingBehavior?: boolean;
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
  faicMCD?: string;
  additionalTrackingVariables?: string;
}

export interface OCardStandardProps {
  componentId?: string;
  contentAlignment?: OCardStandardContentAlignment;
  padding?: OCardStandardPadding;
  mMediaImage?: MMediaImageProps;
  aEyebrow?: AEyebrowProps;
  aSubheader?: ASubheaderProps;
  aAccentLine?: AAccentLineProps;
  aBody?: ABodyProps;
  mButton?: MButtonProps;
  mButton2?: MButtonProps;
  mTag?: MTagProps;
  ctaLink?: string;
  className?: string;
  trackingProperties?: OCardStandardTrackingProperties;
}
